import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserState } from '../state/current-user.state';
import { AppUserRole } from '../models/enums/appUserRole.enum';

export const portalGuard: CanActivateFn = () => {
  const currentUserState = inject(CurrentUserState);
  const router = inject(Router);

  if (currentUserState.user()?.role === AppUserRole.Customer) {
    return true;
  }

  router.navigate(['/forbidden']);
  return false;
};
